import { useAppointmentModal } from "@/contexts/AppointmentModalContext";
import { useAppointmentPaymentInfo } from "./useAppointmentPaymentInfo";

/**
 * Hook to get payment info for the current appointment in the modal context.
 * Returns the React Query result for payment info.
 */
export function useAppointmentModalPaymentInfo() {
  const { appointmentId } = useAppointmentModal();
  return useAppointmentPaymentInfo(appointmentId ?? 0);
}
